import React from "react";
import { Link } from "react-router-dom";
import { usePageTitle } from "@/lib/usePageTitle";

const Sprig = () => (
  <div className="sprig">
    <span className="line" />
    <svg width="26" height="18" viewBox="0 0 26 18" fill="none" stroke="#C97C8C" strokeWidth="1.1"><path d="M2 16C10 12 16 6 24 2" /><path d="M8 12 6 8M13 8l-1-4M18 5l-1-4" strokeLinecap="round" /></svg>
    <span className="line" />
  </div>
);

export default function About() {
  usePageTitle("Our Standard — Olivia Does");
  const stages = [
    ["Stage 1", "Application & references", "Trading history, insurance and two verifiable references before anyone's considered."],
    ["Stage 2", "In-person interview", "We meet every partner face to face — no panel spot is filled remotely."],
    ["Stage 3", "Insurance & qualification checks", "Public liability, trade certification and right-to-work, verified and kept current."],
    ["Stage 4", "Trial job review", "The first two jobs are reviewed closely before a partner joins the regular rotation."],
  ];
  return (
    <section className="od-section od-wrap" data-testid="about-page" style={{ maxWidth: 760 }}>
      <div className="od-eyebrow">Our standard</div>
      <h1 className="serif" style={{ fontSize: "2.3rem", fontWeight: 500, margin: "0 0 20px" }}>Held to a higher mark.</h1>
      <p style={{ color: "var(--taupe)", lineHeight: 1.75, marginBottom: 36 }}>A home isn't a job site — it's where someone keeps what they actually care about, often while they're still living in it. So we don't treat vetting as a box ticked once and forgotten. Every partner goes through the same four checks before they ever see a customer's address — and it doesn't stop once they're on the panel.</p>
      <div className="ogrid cols-2" style={{ marginBottom: 40 }}>
        {stages.map(([stage, title, body], i) => (
          <div className="card" key={stage} data-testid={`vet-stage-${i + 1}`}>
            <div className="od-eyebrow" style={{ marginBottom: 10 }}>{stage}</div>
            <h3>{title}</h3><p>{body}</p>
          </div>
        ))}
      </div>
      <Sprig />
      <div style={{ marginTop: 40 }}>
        <h3 className="serif" style={{ fontWeight: 500 }}>Payment, protected.</h3>
        <p style={{ color: "var(--taupe)", lineHeight: 1.7 }}>Your payment stays with us until the work is signed off — not handed over on-site. We hold it until you've approved the work, then pay our partner directly, usually within 24–48 hours. And if something isn't right, we make it right, at no extra cost to you.</p>
      </div>
      <div style={{ marginTop: 40 }}>
        <Link to="/book" className="btn primary" data-testid="about-cta-book">Book a job</Link>
      </div>
    </section>
  );
}
